import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import About from './about/about'
import Contact from './contact/contact'
import Home from './home/home'
import Menu from './menu/menu'
import Products from './products/products'
import Footer from './footer/footer'
import Webchat from './webchat'


function App() {
  return (
    <Router>
    <div>
     <Menu />
     <Switch>

     <Route path="/" exact component={Home}></Route>
     <Route path="/about" component={About}></Route>
     <Route path="/products" component={Products}></Route>
     <Route path="/contact" component={Contact}></Route>
     
     
     </Switch>
    <Webchat />
     <Footer />
     </div>
     </Router>
  );
}

export default App;
